var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaylistIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 14H3V21H10V14Z",
    fill: "#B08C3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.57129 13.9989C2.57129 13.7622 2.76317 13.5703 2.99986 13.5703H9.99986C10.2366 13.5703 10.4284 13.7622 10.4284 13.9989V20.9989C10.4284 21.2356 10.2366 21.4275 9.99986 21.4275H2.99986C2.76317 21.4275 2.57129 21.2356 2.57129 20.9989V13.9989ZM3.42843 14.4275V20.5703H9.57129V14.4275H3.42843Z",
    fill: "#B08C3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 3H3V10H10V3Z",
    fill: "#B08C3D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.57129 2.99888C2.57129 2.76219 2.76317 2.57031 2.99986 2.57031H9.99986C10.2366 2.57031 10.4284 2.76219 10.4284 2.99888V9.99888C10.4284 10.2356 10.2366 10.4275 9.99986 10.4275H2.99986C2.76317 10.4275 2.57129 10.2356 2.57129 9.99888V2.99888ZM3.42843 3.42746V9.57031H9.57129V3.42746H3.42843Z",
    fill: "#B08C3D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 4C13 3.44772 13.4477 3 14 3H21C21.5523 3 22 3.44772 22 4C22 4.55229 21.5523 5 21 5H14C13.4477 5 13 4.55229 13 4Z",
    fill: "#B08C3D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 9C13 8.44772 13.4477 8 14 8H21C21.5523 8 22 8.44772 22 9C22 9.55229 21.5523 10 21 10H14C13.4477 10 13 9.55229 13 9Z",
    fill: "#B08C3D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 15C13 14.4477 13.4477 14 14 14H21C21.5523 14 22 14.4477 22 15C22 15.5523 21.5523 16 21 16H14C13.4477 16 13 15.5523 13 15Z",
    fill: "#B08C3D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 20C13 19.4477 13.4477 19 14 19H21C21.5523 19 22 19.4477 22 20C22 20.5523 21.5523 21 21 21H14C13.4477 21 13 20.5523 13 20Z",
    fill: "#B08C3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaylistIcon);
export default __webpack_public_path__ + "static/media/playlist-icon.46719538957c16943ade3bba9739d372.svg";
export { ForwardRef as ReactComponent };